import React, { useEffect, useState } from 'react'
import AxiosAuth from '../../utility/AxiosAuth';
import ConfigApi from '../../utility/ConfigApi';
import InitInfo from '../../utility/InitInfo';
import { useTemplate } from '../../context/TemplateProvider';
import { useModal } from '../../context/ModalContext';
import { handleFormSubmit } from '../../utility/formHelpers';
import { useAuth } from '../../context/AuthProvider';
import Autocomplete from '../../components/Autocomplete';

const CollectionModal=({onSubmit,customerData})=>{
    const [searchData,setSearchData]=useState();

    return (
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
      <form onSubmit={onSubmit} className="space-y-6">    
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
          Borrower Name
          </label>
          <Autocomplete data={customerData} setSearchData={setSearchData} showCol="name"/>
          <input
              type="hidden"
              name="member_sl" 
              value={searchData?.sl}
           />
        </div>
      
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Contact Number
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="contact"
              placeholder="Type Contact Number"
              defaultValue={searchData?.contact}
              readOnly
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Amount
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="amount"
              placeholder="Type Amount"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Interest Rate (%)
          </label>
          <div className="mt-2">
            <input
              type="text"
              name="interest_rate"
              placeholder="Type Interest Rate (%)"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Interest Rate By
          </label>
          <div className="mt-2">
          <select name="interest_rate_by" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
          <option selected>Choose Interest Rate By</option>
          <option value="yearly">Yearly</option>
          <option value="monthly">Monthly</option>
        </select>
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            Start Date
          </label>
          <div className="mt-2">
            <input
              type="date"
              name="start_date"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <label htmlFor="text" className="block text-sm font-medium leading-6 text-gray-900">
            End Date
          </label>
          <div className="mt-2">
            <input
              type="date"
              name="end_date"
              className="block w-full rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            />
          </div>
        </div>
        <div>
          <button type="submit"
            className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Create New
          </button>
        </div>
      </form>
    </div>
    )
  }

function FinanceTransactionInfo() {
    const {userId} = InitInfo();
    const [isLoading, setIsLoading] = useState(false)
    const {setUserSl } = useAuth();
    const [CollectionData, setCollectionData] = useState()
    const [error, setError] = useState(null)
    const {setMessage,setLoading,setHeaderText}=useTemplate()
    const [searchData,setSearchData]=useState();
    const [accData, setAccData] = useState()
    const [preBalance, setPreBalance] = useState(0)

    const onSearchSubmit = async (event) => {
        event.preventDefault();
        setLoading(123)
        try {
          const data = await handleFormSubmit(ConfigApi.TRANSACTION_LIST, event.currentTarget, setIsLoading, setError);
          setLoading();
          
          if (data?.error===0) {          
            setCollectionData(data.data);  
            setPreBalance(data.previousBalance)
            setMessage({type: 'success', text: data?.message})
          }else{
            if (data.error===10) {
              setUserSl('')
              localStorage.setItem('userId', '');
            }
            setMessage({type: 'error', text: data?.message})
          }
        } catch (error) {
        }
    };

    
    useEffect(()=>{
        setHeaderText('Transaction List')
        if (userId) {
          setLoading(123);
          AxiosAuth.post(ConfigApi.TRANSACTION_LIST, {userId})
            .then(({data}) => {
              setLoading();
  
              if (data.error===0) {
                setAccData(data.acc_all_ar)                
              }else{
                setMessage({type: 'error', text: data.message})
              }
              
            })
            .catch(err => {
              console.log(err);
            });
        }
    },[userId])

    let Sl=1;
    let balance=preBalance;
    
  return (
    <div>
        <div className="relative overflow-x-auto sm:rounded-lg">
            <div className="pb-4 bg-white dark:bg-gray-900">
                <label htmlFor="table-search" className="sr-only">Search</label>
                <div className="flex items-center justify-between mt-1">

                    <form onSubmit={onSearchSubmit} className="flex relative w-full">
                        <div className="w-1/5 mr-2">
                          <Autocomplete data={accData} setSearchData={setSearchData} showCol="title"/>
                        </div>
                        <input
                            type="hidden"
                            name="account_id"
                            defaultValue={searchData?.account_id}
                        />
                        <input
                            type="date"
                            name="start_date"
                            className="block w-1/5 mr-2 p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Search for items"
                        />
                        <input
                            type="date"
                            name="end_date"
                            className="block w-1/5 mr-2 rounded-md border-0 py-1.5 pl-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="Search for items"
                        />
                        <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Search</button>

                    </form>
                </div>

            </div>
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" className="p-4">
                            SL
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Date
                        </th>
                        <th scope="col" className="px-6 py-3">
                            Account Info
                        </th>
                      
                        <th scope="col" className="px-6 py-3">
                            Notes
                        </th>
                        <th scope="col" className="px-6 py-3 text-right">
                            Debit Amount
                        </th>
                        
                        <th scope="col" className="px-6 py-3 text-right">
                            Credit Amount
                        </th>
                        <th scope="col" className="px-6 py-3 text-right">
                            Balance
                        </th>
                      
                    </tr>
                </thead>
                <tbody>
                  {preBalance>0?(
                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={8999}>
                          <td colSpan={6} className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white'>Previous Balance</td>
                          <td className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white text-right'>{balance}</td>
                        </tr>
                    ):null}
                    {CollectionData && CollectionData.map((row)=>
                     { 
                      balance =balance+row?.creditAmount;
                      balance =balance-row?.debitAmount;
                      return (
                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={row.sl}>
                          <td className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white'>{Sl++}</td>
                          <td className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white'>{row?.timeIssue}</td>
                          <td className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white'>{row?.accountInfo}</td>
                          <td className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white'>{row?.notes}</td>
                          <td className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white text-right'>{row?.debitAmount}</td>
                          <td className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white text-right'>{row?.creditAmount}</td>
                          <td className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white text-right'>{balance}</td>
                        </tr>
                      )}
                    )}
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" key={899}>
                          <td colSpan={6} className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white'> Balance</td>
                          <td className='className="px-6 py-3 font-medium text-gray-900 whitespace-nowrap dark:text-white text-right'>{balance}</td>
                        </tr>
                </tbody>
            </table>
        </div>
    </div>
  )
}

export default FinanceTransactionInfo